import React, { useEffect } from 'react';

import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';

import { AnnouncementBanner } from './AnnouncementBanner';
import { EXO_SKELETON_SCOPE_NAME } from '../../consts';
import { useFeatureFlag } from '../LaunchDarklyProvider';

export const ConnectedAnnouncementBanner = () => {
  const { value: announcementBannerDetails } = useFeatureFlag(
    'announcement-banner-details',
    {},
  );

  useEffect(() => {
    if (announcementBannerDetails) {
      const { text, startDate, endDate, ...otherProps } =
        announcementBannerDetails;

      if (Object.keys(otherProps).length > 0) {
        report({
          scope: EXO_SKELETON_SCOPE_NAME,
          type: REPORT_TYPES.warning,
          value:
            'There is unused fields in AnnouncementBanner Feature Flag, please check configuration',
          context: { unusedFields: otherProps },
        });
      }
    }
  });
  if (
    !announcementBannerDetails ||
    Object.keys(announcementBannerDetails).length === 0
  ) {
    return null;
  }

  return <AnnouncementBanner {...announcementBannerDetails} />;
};
